export default __webpack_public_path__ + "static/header-logo-hr-860f4e7d3f8488703835841d53acaa86.png";